// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"195":"b281160bde180123458d","227":"c831b7bbf69d669f5e4d","613":"1b55013c62d99bfbcdff","764":"f63e895f7211a41220ef","931":"dd05e34e120ed44eeef9"}[chunkId] + ".css";
};